import { render, staticRenderFns } from "./Shopcar.vue?vue&type=template&id=4f9c559c&scoped=true"
import script from "./Shopcar.vue?vue&type=script&lang=js"
export * from "./Shopcar.vue?vue&type=script&lang=js"
import style0 from "./Shopcar.vue?vue&type=style&index=0&id=4f9c559c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c559c",
  null
  
)

export default component.exports